module.exports = __webpack_public_path__ + "img/1572015254.7d16be5d.jpg";